import { mainSiteUrl } from "@/mocks/categories";

export default function CtaBanner() {
  return (
    <section className="py-16 md:py-24 bg-background-100 relative overflow-hidden">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-2xl mx-auto text-center relative z-10">
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950 leading-tight">
            Ready to Shop <span className="text-primary-500">Smarter?</span>
          </h2>
          <p className="mt-4 text-sm md:text-base text-foreground-600 max-w-md mx-auto">
            Access verified sellers and exclusive spreadsheets. Skip the risk and start buying with confidence today.
          </p>
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 mt-8 px-8 py-3.5 bg-primary-500 text-background-50 rounded-full text-base font-semibold hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            Buy It Now
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line"></i>
            </span>
          </a>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 opacity-[0.04] pointer-events-none">
        <div className="flex justify-center gap-8 md:gap-16">
          <span className="w-20 h-20 md:w-28 md:h-28 rounded-full bg-primary-500"></span>
          <span className="w-16 h-16 md:w-24 md:h-24 rounded-full bg-accent-500 mt-8"></span>
          <span className="w-24 h-24 md:w-32 md:h-32 rounded-full bg-secondary-500 mt-4"></span>
          <span className="w-14 h-14 md:w-20 md:h-20 rounded-full bg-primary-500 mt-12"></span>
          <span className="w-20 h-20 md:w-28 md:h-28 rounded-full bg-accent-500 mt-2"></span>
        </div>
      </div>
    </section>
  );
}